import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import { fetchCriticalAnomalies, type AnomalyListResponse } from '../../services/analytics.service';

type Props = {
  daysBack?: number;
  onClickFilterCritical?: () => void;
};

export default function CriticalAlertsBanner({ daysBack = 7, onClickFilterCritical }: Props) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      const res = await fetchCriticalAnomalies({ page: 1, page_size: 1, days_back: daysBack });
      if (!active) return;
      const data = res.data as AnomalyListResponse;
      setCount(data.total ?? 0);
    };
    load();
    return () => {
      active = false;
    };
  }, [daysBack]);

  if (count === null || count === 0) return null;

  return (
    <Alert severity="error" variant="outlined" sx={{ alignItems: 'center' }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between">
        <AlertTitle>{count} Critical Anomalies</AlertTitle>
        <Button color="error" variant="contained" size="small" onClick={onClickFilterCritical}>
          Show Critical Only
        </Button>
      </Stack>
    </Alert>
  );
}
